module.exports = __webpack_public_path__ + "img/footer-white-left.ff399b61.png";